import {
  ListMultiServiceAvailabilityTimeSlotsRequest,
  ListMultiServiceAvailabilityTimeSlotsResponse,
} from '@wix/ambassador-bookings-availability-v2-time-slot/types';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { CalendarState } from '../../components/BookingCalendar/controller';
import { listMultiServiceAvailabilityTimeSlots as listMultiServiceAvailabilityTimeSlotHttpRequest } from '@wix/ambassador-bookings-availability-v2-time-slot/http';

export const listMultiServiceAvailabilityTimeSlots = async (
  listMultiServiceAvailabilityTimeSlotRequest: ListMultiServiceAvailabilityTimeSlotsRequest,
  flowAPI: ControllerFlowAPI,
  state: CalendarState,
): Promise<ListMultiServiceAvailabilityTimeSlotsResponse> => {
  try {
    // void panoramaQueryAvailabilityInteractionStart({
    //   flowAPI,
    //   state,
    //   request: listEventTimeSlotsRequest,
    // });
    const response = (
      await flowAPI.httpClient.request(
        listMultiServiceAvailabilityTimeSlotHttpRequest(
          listMultiServiceAvailabilityTimeSlotRequest,
        ),
      )
    ).data;

    // void panoramaQueryAvailabilityInteractionEnd({
    //   flowAPI,
    //   response,
    // });

    return response;
  } catch (e) {
    // void panoramaQueryAvailabilityInteractionEnd({
    //   flowAPI,
    //   error: e as string,
    // });
    throw e;
  }
};
